import { render, staticRenderFns } from "./NotiModal.vue?vue&type=template&id=2eb3f379&scoped=true"
import script from "./NotiModal.vue?vue&type=script&lang=js"
export * from "./NotiModal.vue?vue&type=script&lang=js"
import style0 from "./NotiModal.vue?vue&type=style&index=0&id=2eb3f379&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb3f379",
  null
  
)

export default component.exports